import React from 'react'
import {Icon} from '@chakra-ui/react'

const ReturnIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <g clipPath="url(#clip0_31_640)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.96875 11.0938C4.56384 11.0938 4.15625 11.5013 4.15625 11.9062V28.0938C4.15625 28.4987 4.56384 28.9062 4.96875 28.9062H15.7188V31.9062H4.96875C2.90699 31.9062 1.15625 30.1555 1.15625 28.0938V11.9062C1.15625 9.84449 2.90699 8.09375 4.96875 8.09375H28.0938C30.1555 8.09375 31.9062 9.84449 31.9062 11.9062V19.5729H28.9062V11.9062C28.9062 11.5013 28.4987 11.0938 28.0938 11.0938H4.96875Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.61353 2.95533C7.2242 1.84883 8.50155 1.15625 9.74773 1.15625H23.4686C24.9034 1.15625 25.9121 2.02676 26.5186 2.83542C26.5352 2.85762 26.5512 2.88028 26.5666 2.90337L30.8833 9.37838C31.3428 10.0677 31.1566 10.999 30.4673 11.4585C29.778 11.918 28.8467 11.7318 28.3871 11.0425L24.096 4.60579C23.7895 4.20819 23.5729 4.15625 23.4686 4.15625H9.74773C9.65494 4.15625 9.52964 4.187 9.40982 4.25748C9.35318 4.2908 9.30939 4.32638 9.279 4.35734C9.25026 4.38662 9.2401 4.40493 9.23939 4.40621C9.23934 4.4063 9.23933 4.40631 9.23937 4.40624C9.2079 4.46917 9.17205 4.5298 9.13207 4.5877L4.66124 11.0627C4.19054 11.7444 3.25632 11.9155 2.57461 11.4448C1.8929 10.9741 1.72184 10.0399 2.19255 9.35815L6.61353 2.95533Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.5312 1.15625C17.3597 1.15625 18.0312 1.82782 18.0312 2.65625V9.59375C18.0312 10.4222 17.3597 11.0938 16.5312 11.0938C15.7028 11.0938 15.0312 10.4222 15.0312 9.59375V2.65625C15.0312 1.82782 15.7028 1.15625 16.5312 1.15625Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.8857 26.5521C18.8857 25.7237 19.5573 25.0521 20.3857 25.0521H31.9482C35.7058 25.0521 38.8441 28.1904 38.8441 31.948C38.8441 35.7056 35.7058 38.8438 31.9482 38.8438H20.4274V35.8438H31.9482C34.049 35.8438 35.8441 34.0487 35.8441 31.948C35.8441 29.8472 34.049 28.0521 31.9482 28.0521H20.3857C19.5573 28.0521 18.8857 27.3806 18.8857 26.5521Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M26.9771 22.0813L22.5063 26.5521L26.9771 31.0229L24.8558 33.1443L18.2637 26.5521L24.8558 19.96L26.9771 22.0813Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_31_640">
                    <rect
                        width="40"
                        height="40"
                        fill="white"
                        transform="translate(0 0.000366211)"
                    />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default ReturnIcon
